import { render, staticRenderFns } from "./common-ad-down.vue?vue&type=template&id=274c89d2&scoped=true&"
import script from "./common-ad-down.vue?vue&type=script&lang=js&"
export * from "./common-ad-down.vue?vue&type=script&lang=js&"
import style0 from "./common-ad-down.vue?vue&type=style&index=0&id=274c89d2&scoped=true&lang=scss&"
import style1 from "./common-ad-down.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274c89d2",
  null
  
)

export default component.exports